import { asNodeIDArray } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import { AcademicSubject, ClassYear } from "../../../Utilities";

export type StandardFilterFormValues = {
	academicSubjectIDIn: AcademicSubject["id"][];
	classYearIDsIn: ClassYear["id"][];
};

export const initialStandardFilters: StandardFilterFormValues = {
	academicSubjectIDIn: [],
	classYearIDsIn: [],
};

export const standardFiltersTypeFilterObject: TypeFilterObject<StandardFilterFormValues> = {
	academicSubjectIDIn: asNodeIDArray,
	classYearIDsIn: asNodeIDArray,
};
